<!-- for login page as it has an additional template -->
@if(!this.pageLoading){
<ng-container *ngIf="page.pageType?.trim() === pageTypes.loginPage">
  <div class="px-2">
  <mat-form-field class="w-100 mt-2" appearance="outline">
    <mat-label>Login Type</mat-label>
    <mat-select matNativeControl required placeholder="Project Name" [value]="'Username & Password'">
      <ng-container *ngFor="let item of ['Username & Password']">
        <mat-option [value]='item'>{{item}}</mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
    <div class="toggle-container custom-toggle-container">
      <mat-slide-toggle [checked]="selectedPage.forms?.[0]?.widgets[0]?.widgetConfig?.enable"
        (change)="slideTiggleChange($event,0,0,selectedPage.forms?.[0]?.widgets[0]?.widgetId)">
        <span class="font-add">Logo</span>
      </mat-slide-toggle>
    </div>
    <div class="toggle-container custom-toggle-container">
      <mat-slide-toggle [checked]="selectedPage.forms?.[0]?.widgets[5]?.widgetConfig?.enable"
        (change)="slideTiggleChange($event,5,0,selectedPage.forms?.[0]?.widgets[5]?.widgetId)">
        <span class="font-add">Forget Password</span>
      </mat-slide-toggle>
    </div>
    <div class="toggle-container custom-toggle-container">
      <mat-slide-toggle [checked]="selectedPage.forms?.[0]?.widgets[7]?.widgetConfig?.enable"
        (change)="slideTiggleChange($event,7,0,selectedPage.forms?.[0]?.widgets[7]?.widgetId)">
        <span class="font-add">Biometrics</span>
      </mat-slide-toggle>
    </div>
    }
  </div>
</ng-container>
<!-- for all pages -->
<!-- <ng-container> -->
<!-- Page sections -->
<mat-accordion displayMode="flat" togglePosition="before"
  [ngStyle]="pagesSheffelInProcess ? {'pointer-events': 'none', 'opacity': '0.5'} : {}">
  <mat-expansion-panel [expanded]="sectionsPanel" (closed)="sectionsPanel = false" >
    <mat-expansion-panel-header [class.active]="activePagePanel === 'components' && pagePanelStatus"
      (click)="pagePanelStatusSetter('components')">
      <mat-panel-title>Sections</mat-panel-title>
    </mat-expansion-panel-header>

    <mat-accordion displayMode="flat" togglePosition="before">
      <ng-container *ngFor="let form of selectedPage.forms; let i = index">

        <!-- Navigation Bar handling -->
        <ng-container *ngIf="form.formConfig?.formType === formTypes['navbar']">
          <!-- toogle to enable or disable navbar -->
          @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
          <div class="toggle-container custom-toggle-container">
            <mat-slide-toggle [checked]="form.formConfig?.enable" (change)="updateForm(true, $event)">
              <span class="font-add">{{ form.formConfig?.enable ? 'Disable' : 'Enable' }} Navbar</span>
            </mat-slide-toggle>
          </div>
          }

          <mat-expansion-panel [expanded]="form?.open" *ngIf="form.formConfig?.enable" class="mb-2">
            <!-- section label -->
            <mat-expansion-panel-header [class.active]="form?.open || false"
              (click)="sectionFormRenderer(page,pageIndex,i,form,true)">
              <mat-panel-title>{{form.formLabel| titlecase}}</mat-panel-title>
            </mat-expansion-panel-header>
            <!--navbar  widgets  -->
            <div class="widget-drop-container ">
              <div  *ngFor="let widget of form.widgets; let j = index"
                >
                <div class="widget-item non-draggable d-flex" [class.selected]="widget.open" (click)="checkWidgetEnabled(page,i,j,widget)">
                  <div class="flex-fill">{{widget.widgetLabel || widget?.widgetConfig?.element?.label || "Component" |
                    titlecase}}</div>
                  
                  <!-- toggle to enable or disable navbar widgets -->
                   <div class="">
                     @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                     <mat-slide-toggle *ngIf="j > 1" [checked]="widget.widgetConfig?.enabled"
                       (change)="changeOn($event,j,i)"></mat-slide-toggle>
                     }
                   </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </ng-container>

        <!-- Regular forms  -->
        <ng-container
          *ngIf="form.formConfig?.formType !== 'Navgation Bar' && form.formConfig?.formType !== 'menuPanel'">
          <mat-expansion-panel [expanded]="form?.open" class="mb-1" >
            <mat-expansion-panel-header [class.active]="form?.open"
              (click)="sectionFormRenderer(page,pageIndex,i,form,true)">
              <mat-panel-title>{{form.formLabel| titlecase}}</mat-panel-title>
            </mat-expansion-panel-header>

            <!-- drop list for widgets  -->
            <div class="widget-drop-container drag-boundary" cdkDropList (cdkDropListDropped)="rearrangeWidgets($event)"
              [cdkDropListData]="form.widgets" cdkDropListOrientation="vertical"
              (mousedown)="onWidgetAreaMouseDown($event)" (mouseup)="onWidgetAreaMouseUp($event)">

              <ng-container *ngFor="let widget of form.widgets; let j = index">
                @if(page?.pageType?.trim() === pageTypes.loginPage) {
                <!-- Login page widgets (non-draggable) -->
                <div class="widget-item non-draggable" [class.selected]="widget.open"
                  *ngIf="widget?.widgetConfig?.enable" (click)="widgetFormRenderer(page,i,j,widget)">
                  {{widget.widgetLabel||widget?.widgetConfig?.element?.label || "Component" | titlecase}}
                </div>

                } @else {
                <!-- Regular draggable widgets -->
                <div class="widget-item draggable-widget" [class.selected]="widget.open" cdkDrag
                  cdkDragBoundary=".drag-boundary" (click)="widgetFormRenderer(page,i,j,widget)"
                  (cdkDragStarted)="onWidgetDragStarted($event)" (cdkDragEnded)="onWidgetDragEnded($event)"
                  *ngIf="(page?.pageType?.trim() === pageTypes.dataListView && widget?.widgetConfig?.enable) || page.pageType?.trim() !== pageTypes.dataListView"
                  (mousedown)="onWidgetMouseDown($event)">

                  <div class="drag-placeholder" *cdkDragPlaceholder></div>

                  <span class="d-flex align-items-center justify-content-between gap-3">
                    <span class="text-ellipsis">
                      {{widget.widgetLabel|| widget?.widgetConfig?.element?.label|| "Component" | titlecase}}
                    </span>
                    <div class="item-end control-buttons">
                      @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                      <button mat-icon-button color="warn" class="mat-small"
                        *ngIf="page?.pageType != pageTypes.loginPage && page?.pageType!=pageTypes.splashScreen && page.pageType?.trim() != pageTypes.previewPage"
                        (click)="onSideNavWidgetDeleteClick(i,form,widget?.widgetId,widget)">
                        <mat-icon>delete</mat-icon>
                      </button>
                      }
                    </div>
                  </span>
                </div>
                }

              </ng-container>
            </div>
          </mat-expansion-panel>
        </ng-container>
      </ng-container>
    </mat-accordion>

    @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
    <button mat-stroked-button color="primary"
      *ngIf="page?.pageType != pageTypes.loginPage && page?.pageType!=pageTypes.splashScreen && page.pageType?.trim() != pageTypes.previewPage"
      class="add-button w-100 mt-3" (click)="subNavValueSetter(page,'addComponent')">
      <mat-icon>add</mat-icon>
      Add Component
    </button>
    }
  </mat-expansion-panel>
</mat-accordion>
} @else {
<!-- @if(page.open){ -->
<div style="height: 100px;">
  <mat-spinner diameter="30" class="imageCenter position-relative"></mat-spinner>
</div>
<!-- } -->
}
<!-- </ng-container> -->